import { Directive, effect, ElementRef, EmbeddedViewRef, inject, input, OnDestroy, OnInit, Renderer2, TemplateRef, ViewContainerRef } from "@angular/core";
import { Checkbox } from "@openng/optimus-ui/checkbox";
import { RadioButton } from "@openng/optimus-ui/radiobutton";
import { Utils } from "src/modules/utils/shared/utils";

@Directive({
    standalone: false,
    selector: 'p-checkbox[appLabel], p-radioButton[appLabel]'
})
export class PrimeLabelDirective implements OnInit, OnDestroy {
    private readonly checkboxHost = inject(Checkbox, { optional: true });
    private readonly radioButtonHost = inject(RadioButton, { optional: true });
    private readonly renderer = inject(Renderer2);
    private readonly elementRef = inject(ElementRef);
    private readonly viewContainerRef = inject(ViewContainerRef);

    public readonly label = input.required<string | TemplateRef<unknown>>({ alias: 'appLabel' });

    private labelElement: HTMLLabelElement;
    private viewRef: EmbeddedViewRef<unknown> = null;

    constructor() {
        effect(() => {
            this.fillLabel(this.label());
        });
    }

    ngOnInit(): void {
        const id = Utils.generateGuid();

        this.labelElement = document.createElement('label');
        this.renderer.setStyle(this.labelElement, "margin-top", "2px");
        if (this.checkboxHost) {
            this.checkboxHost.inputId = id;
        } else if (this.radioButtonHost) {
            this.radioButtonHost.inputId = id;
        }
        this.renderer.setAttribute(this.labelElement, 'for', id);
        this.renderer.appendChild(this.elementRef.nativeElement, this.labelElement);
        this.renderer.setStyle(this.elementRef.nativeElement, "width", "auto");
    }

    ngOnDestroy(): void {
        this.viewRef?.destroy();
    }

    private fillLabel(label: string | TemplateRef<unknown>): void {
        if (this.viewRef) {
            this.viewRef.destroy();
            this.viewRef = null;
        }
        this.labelElement.innerText = '';

        if (label instanceof TemplateRef) {
            this.viewRef = this.viewContainerRef.createEmbeddedView(label);
            this.viewRef.rootNodes.forEach(node => this.renderer.appendChild(this.labelElement, node));
        } else {
            this.labelElement.innerText = label;
            this.labelElement.classList.add("ml-2");
        }
    }
}
